import request from '@/utils/request'

const url = '/erp/freight-rule'

export function pageFreightRule (params) {
  return request({ url: url + '/page', method: 'get', params })
}

export function getFreightRule (id) {
  return request({ url: url + '/detail', method: 'get', params: { id } })
}

export function addFreightRule (data) {
  return request({ url: url + '/add', method: 'post', data })
}

export function editFreightRule (data) {
  return request({ url: url + '/edit', method: 'post', data })
}

export function deleteFreightRule (id) {
  return request({ url: url + '/delete', method: 'post', data: { id } })
}

export function syncFreightRule (ids) {
  return request({ url: url + '/sync', method: 'post', data: { ids } })
}
